import { render, staticRenderFns } from "./CourseMaterialAttachment.vue?vue&type=template&id=4a904b19&scoped=true&"
import script from "./CourseMaterialAttachment.vue?vue&type=script&lang=ts&"
export * from "./CourseMaterialAttachment.vue?vue&type=script&lang=ts&"
import style0 from "./CourseMaterialAttachment.vue?vue&type=style&index=0&id=4a904b19&lang=scss&scoped=true&"
import style1 from "./CourseMaterialAttachment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a904b19",
  null
  
)

export default component.exports